export default __webpack_public_path__ + "static/media/ekaleido_logo_h.f667b2f3.png";